import axios from "axios"


import * as actions from "../actions/candidateBoard"

export function addCandidateBoard(candidateBoard) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(process.env.REACT_APP_API_HOST + "/api/candidateboard/", candidateBoard)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.addCandidateBoardToCandidate(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getCandidateBoardsForCandidate(candidateId) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/candidateBoard/get-boards/" + candidateId)
      .then((response) => {
        let candidateBoards = response.data ? response.data.$values : []
        dispatch(actions.getCandidateBoardsForCandidate(candidateBoards))
      })
  }
}

export function getCandidateBoard(candidateBoardId) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/candidateBoard/get-board/" + candidateBoardId)
       .then((response) => {
        let candidateBoard = response && response.data ? response.data : {}
        dispatch(actions.getCandidateBoard(candidateBoard))
      })
  }
}

export function updateCandidateBoard(candidateBoard) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(process.env.REACT_APP_API_HOST + "/api/candidateboard/", candidateBoard)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.updateCandidateBoard(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function deleteCandidateBoard(candidateBoardId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.delete(process.env.REACT_APP_API_HOST + "/api/candidateboard/delete-board/" + candidateBoardId)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.removeBoardFormCandidate(candidateBoardId))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function clearCandidateBoard() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearCandidateBoard())
      resolve()
    })
  }
}

export function clearCandidateBoardFromCandidate() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearCandidateBoardFromCandidate())
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/actionCreators/candidateBoard.js